export const addNewLine = (text) => {
    // Remember to use white-spce: pre-line css property on the specific element which you want to 
    // use this function for.
    // This function will get a text then add line breaks for it after each 2 words
    let result = text.replace(/(.*?\s.*?\s)/g, '$1 \n');
    return result;
}